module.exports = __webpack_public_path__ + "img/18.8854aa24.jpg";